<template>
  <div class="open-private-display">
    <sub-menu :activeNum="1"></sub-menu>
    <div class="business-title">
      <button class="addapp private-create" @click="openCreatePrivate" v-if="loaded && privateList.length > 0">
        <span class="icon-plus"></span>
        <span class="text">申请私有云授权</span>
      </button>
      <button class="addapp pswadd" @click="openAddDialog" v-if="loaded && privateList.length > 0">
        <span class="icon-plus"></span>
        <span class="text">通过密码添加</span>
      </button>
    </div>
    <div v-if="loaded && privateList.length > 0">
      <div class="private-list" v-for="(privateItem, index) in privateList" :key="index">
        <div class="header">
          <div class="border" :class="{'border-test': applyStatusHelper.common.calculateTitleStyle(privateItem.applytype == privateApplyKeyType.TEST)}"></div>
          <div class="thead-title">
            <div class="private-name" :title="privateItem.svctypeNames">{{privateItem.svctypeNames}}</div>
            <span class="status"
              :class="[applyStatusHelper.common.calculateTitleStyle(privateItem.applytype == privateApplyKeyType.TEST) ? 'status-test' : 'status-normal']">
            </span>
            <div class="check"
              :class="applyStatusHelper.common.calculateStyle(privateItem.status, ['checking', 'check-success', 'check-fail'])">
              <div class="status-result">
                {{(privateItem.isrenewal == 1) ? "续期" : ""}}{{applyStatusHelper.common.displayText(privateItem.status)}}
              </div>
              <div class="review-info">
                <div class="status-item-text" v-if="privateItem.status == PrivateStatusKey.VERIFY_FAIL ||
                  applyStatusHelper.common.containStatus(privateItem.status, [PrivateStatusKey.FORMAL_VERIFY_FAIL])">
                  <span class="status-item-label">审核失败原因：</span>
                  <span class="status-item-reason">{{privateItem.reason}}</span>
                </div>
                <div class="status-time-appid"
                :class="{'disable-to-use' : (applyStatusHelper.common.claculateExpirationStatus(privateItem.status) || privateItem.expired)}">
                  <span v-if="(applyStatusHelper.common.containStatus(privateItem.status, [PrivateStatusKey.FORMAL_VERIFY_SUCCESS, PrivateStatusKey.FORMAL_AUTH_OVER]) || (applyStatusHelper.common.containStatus(privateItem.status, [PrivateStatusKey.FORMAL_VERIFYING, PrivateStatusKey.FORMAL_VERIFY_FAIL])) && privateItem.isrenewal == 1) && privateItem.validbegin">
                    <span>授权时间: {{privateItem.validbegin}} - {{privateItem.validend}}</span>
                  </span>
                  <span v-else>
                    <span v-if="(applyStatusHelper.common.containStatus(privateItem.status, [PrivateStatusKey.VERIFY_SUCCESS, PrivateStatusKey.AUTH_OVER]) || (applyStatusHelper.common.containStatus(privateItem.status, [PrivateStatusKey.VERIFYING, PrivateStatusKey.VERIFY_FAIL]) && privateItem.isrenewal == 1)) && privateItem.validbegin">
                      测试时间: {{privateItem.validbegin}} - {{privateItem.validend}}
                    </span>
                  </span>
                </div>
                <div class="status-time-appid" :class="{'disable-to-use' : (applyStatusHelper.common.claculateExpirationStatus(privateItem.status) || privateItem.expired)}">
                  <!-- 新增AppId -->
                  <span v-if="privateItem.appid != ''">App ID: {{privateItem.appid}}</span>
                  <span class="secret appid" v-if="privateItem.secretkey != ''">SecretKey: {{privateItem.secretkey}}</span>
                </div>
              </div>
            </div>
            <div class="private-edit-btn-group" v-if="!applyStatusHelper.common.containStatus(privateItem.status, [PrivateStatusKey.VERIFYING, PrivateStatusKey.FORMAL_VERIFYING])" >
              <button class="g-btn-view renewal-apply-btn"
                v-if="applyStatusHelper.common.calculateRenewal(privateItem.status, privateItem.isrenewal) && privateItem.applysource === ''"
                @click="handleApplyRenewalPrivate(privateItem)">申请续期</button>
              <button
                class="g-btn-view private-to-formal"
                v-if="applyStatusHelper.common.calculateProductStyle(privateItem.status, privateItem.isrenewal, privateItem.applytype)"
                @click="handleChangeToFormalPrivate(privateItem)">申请正式授权</button>
              <button
                class="private-del-btn g-btn-delete"
                v-if="privateItem.applysource === ''"
                @click="handleDeletePrivate(privateItem.id)">删除</button>
            </div>
          </div>
        </div>
        <div class="private-info"
          :class="{'private-view-fail': (privateItem.status == PrivateStatusKey.VERIFY_FAIL || privateItem.status == PrivateStatusKey.FORMAL_VERIFY_FAIL) && privateItem.isrenewal != 1}">
          <div class="private-info-row">
            <div class="private-info-column">
              <div class="private-label lable-left">授权类型:</div>
              <div class="private-value value-left">{{DisplayMapper.AUTH_TYPE[privateItem.authtype]}}</div>
            </div>
            <div class="private-info-column">
              <div class="private-label lable-left">授权机器:</div>
              <div class="private-value value-left">{{DisplayMapper.MECHINE_TYPE[privateItem.machinetype]}}</div>
            </div>
          </div>
          <div class="private-info-row" v-if="privateItem.scope == JoinWay.EXTERNAL">
            <div class="private-info-column">
              <div class="private-label lable-left">企业名称:</div>
              <div class="private-value private-hide-text" :title="privateItem.extname">{{privateItem.extname}}</div>
            </div>
            <div class="private-info-column">
              <div class="private-label lable-right">企业网址:</div>
              <div class="private-value private-hide-text">
                <div v-if="privateItem.exturl" :title="privateItem.exturl">{{privateItem.exturl}}</div>
                <div v-else>--</div>
              </div>
            </div>
          </div>
          <div class="private-info-row" v-if="privateItem.scope == JoinWay.EXTERNAL">
            <div class="private-info-column">
              <div class="private-label lable-left">优图接口人邮箱:</div>
              <div class="private-value private-hide-text" :title="privateItem.ytcontact">{{privateItem.ytcontact}}</div>
            </div>
            <div class="private-info-column">
              <div class="private-label lable-right">业务接口人及联系方式:</div>
              <div class="private-value value-right private-hide-text" :title="privateItem.peercontact">{{privateItem.peercontact}}</div>
            </div>
          </div>
          <div class="private-info-row" v-if="privateItem.scope == JoinWay.EXTERNAL">
            <div class="private-info-column">
              <div class="private-label lable-left">营业执照:</div>
              <div class="private-value">
                <a v-if="privateItem.extlicense" target="_blank" :href="privateItem.extlicense" class="display-business-licence">营业执照</a>
                <a v-else>--</a>
              </div>
            </div>
            <div class="private-info-column" v-show="privateItem.applytype == privateApplyKeyType.FORMAL">
              <div class="private-label lable-right">合同文件:</div>
              <div class="private-value value-right special-height" v-if="privateItem.applysource === ''">
                <a target="_blank" class="display-extcontract"
                  v-for="(url, index) in privateItem.contract" :key="index"
                  :href="url">合同文件{{index + 1}}</a>
                <a class="display-extcontract" v-if="privateItem.contract.length < 1">--</a>
              </div>
              <div class="private-value value-right special-height" v-else>--</div>
            </div>
          </div>
          <div class="private-info-row" v-if="privateItem.scope == JoinWay.INTERNAL">
            <div class="private-info-column">
              <div class="private-label lable-left">优图接口人邮箱:</div>
              <div class="private-value value-left private-hide-text" :title="privateItem.ytcontact">{{privateItem.ytcontact}}</div>
            </div>
            <div class="private-info-column">
              <div class="private-label lable-right">业务接口人及联系方式:</div>
              <div class="private-value value-right private-hide-text" :title="privateItem.peercontact">{{privateItem.peercontact}}</div>
            </div>
          </div>
          <div class="private-info-row" v-if="privateItem.scope == JoinWay.INTERNAL">
            <div class="private-info-column">
              <div class="private-label lable-left">业务所属部门:</div>
              <div class="private-value value-left private-hide-text" :title="privateItem.intdept">{{privateItem.intdept}}</div>
            </div>
            <div class="private-info-column" v-show="privateItem.applytype == privateApplyKeyType.FORMAL">
              <div class="private-label lable-right">合作备案:</div>
              <div class="private-value value-right special-height">
                <a target="_blank" class="display-extcontract"
                  v-for="(url, index) in privateItem.contract" :key="index"
                  :href="url">合作备案{{index + 1}}</a>
                <a class="display-extcontract" v-if="privateItem.contract.length < 1">--</a>
              </div>
            </div>
            <div class="private-info-column">
              <div class="private-label lable-right">应用场景:</div>
              <div class="private-value value-right private-hide-text" :title="privateItem.scene" >{{privateItem.scene}}
              </div>
            </div>
          </div>
          <!-- <div class="private-info-row">
            <div class="private-info-column">
              <div class="private-label lable-left describe-scene">应用场景:</div>
              <div class="private-desc desc">
                <description-folder :content="privateItem.scene" />
              </div>
            </div>
          </div>  -->
          <div class="private-info-row">
           <div class="private-info-column">
           <div class="private-label lable-left">申请时间:</div>
           <div class="private-value value-left">{{privateItem.optime}}</div>
           </div>
          </div>
        </div>
        <div class="private-bind-list-container" v-if="applyStatusHelper.common.isDeviceVisible(privateItem.status, privateItem.isrenewal)">
          <div class="bind-title-private">绑定设备列表:</div>
          <div class="private-device-btn-group">
            <a v-if="showHAMode(privateItem)" class="auth-explain" @click="downloadHAModeCSV(privateItem)">下载授权</a>
            <a class="auth-explain" href="https://docs.qq.com/doc/DZEZwdHZGcFJybmFn" target="_blank">授权说明</a>
            <!-- <div v-if="applyStatusHelper.common.isDeviceEditable(privateItem.status, privateItem)" class="bind-button-one" @click="bindDeviceToPrivate(privateItem)">绑定设备</div> -->
            <!-- <div v-if="applyStatusHelper.common.isDeviceEditable(privateItem.status, privateItem)" class="bind-button-series" @click="bindGroupDeviceToPrivate(privateItem)">批量绑定设备</div> -->
            <div v-if="applyStatusHelper.common.isDeviceEditable(privateItem.status, privateItem)" :class="`bind-button-one ${privateItem.is_ha_mode && privateItem.bind_ha_mode ? 'disabled' : ''}`" @click="bindDeviceToPrivate(privateItem)">手动绑定</div>
          </div>
          <div class="private-content">
            <table class="detail-chart">
              <thead>
                <tr>
                  <!-- <th>备注</th> -->
                  <th>设备号</th>
                  <th>设备状态</th>
                  <th>操作</th>
                  <th>备注</th>
                </tr>
              </thead>
              <tbody class="scrollbar"  v-if="privateItem.devices && privateItem.devices.length > 0">
                <tr v-for="(deviceItem, index) in privateItem.devices" :key="index">
                  <td class="device-number" :title="deviceItem.devno">{{deviceItem.devno}}</td>
                  <td>
                    <span v-if="deviceItem.devno" :class="[ deviceItem.status == DeviceStatus.INACTIVE ?  'activated' :'created']">
                      <span class="point"></span>
                      {{ deviceItem.status == DeviceStatus.INACTIVE ? `已激活至${deviceItem.end_time}` : '未激活' }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="delete-button"
                      @click="handleDeleteDevice(privateItem, deviceItem)"
                      v-if="deviceItem.status != DeviceStatus.INACTIVE && deviceItem.devno"
                      >
                      删除
                    </span>
                    <div v-if="!privateItem.bind_ha_mode && deviceItem.status == DeviceStatus.INACTIVE && deviceItem.devno">
                      <div class="download-info" @click="downloadCSV(privateItem, deviceItem)">下载授权</div>
                      <div id="downloadContainer">
                        <div id="downloadForms"></div>
                      </div>
                    </div>
                  </td>
                  <td class="device-remarks">
                    <div class="remarks" v-if="deviceItem.devno">
                      <div class="remarks-content" v-if="deviceItem.remark !== ''" :title="deviceItem.remark">{{deviceItem.remark}}</div>
                      <div class="remarks-content" v-else>暂无</div>
                      <i class="el-icon-edit" @click="showUpdateRemarks(privateItem.id, privateItem.appid, deviceItem.devno, deviceItem.remark)"></i>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="statistics-table">
              <div class="statistics-column-private">
                <div class="title">统计</div>
                <div class="content" v-if="privateItem.deviceStatistics">
                  <div :title="privateItem.deviceStatistics[DeviceAuth.AUTH]">
                    {{privateItem.deviceStatistics[DeviceAuth.AUTH]}}
                  </div>
                  <div :title="privateItem.deviceStatistics[DeviceAuth.ADD]">
                    {{privateItem.deviceStatistics[DeviceAuth.ADD]}}
                  </div>
                  <div :title="privateItem.deviceStatistics[DeviceAuth.ACTIVE]">
                    {{privateItem.deviceStatistics[DeviceAuth.ACTIVE]}}
                  </div>
                </div>
                <div class="content" v-else>
                  已授权0台<br>
                  已添加0台<br>
                  已激活0台<br>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="private-key-show" v-if="privateItem.privateKeyVisible">
           <span class="private-key">Private key:</span>
           <span class="private-key-info">{{privateItem.privateKey}}</span>
        </div>
        <div class="private-mail-receiver">
          <div class="">
            <div class="title-mail">邮件列表:</div>
            <div class="mail-row">
              <div class="receiver-info" :title="privateItem.mailreceiver">{{privateItem.mailreceiver ? privateItem.mailreceiver : '授权到期前会邮件提醒，如有多个接收人请以；分隔'}}</div>
            </div>
            <div class="save-row">
              <el-button @click="showMailReceiverVisible(privateItem)">修改</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="business-empty" v-if="loaded && privateList.length == 0">
      <div class="business-empty-icon"></div>
      <div class="business-empty-text">
        您还没有私有云授权<br>
        单击“申请私有云授权”按钮，申请优图私有云服务授权
      </div>
      <div class="empty-button">
        <button class="addapp" @click="$router.transfer(RouteKey.OPEN_PRIVATE_CREATOR)">
          <span class="icon-plus"></span>
          <span class="text">申请私有云授权</span>
        </button>
        <button class="addapp" @click="openAddDialog">
          <span class="icon-plus"></span>
          <span class="text">通过密码添加</span>
        </button>
      </div>
    </div>
    <!-- 绑定主备设备 -->
    <el-dialog
      title="配置授权服务器"
      :visible.sync="addMainBackVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :before-close="cancleBindDeviceForm"
      width="860px">
      <div class="device-button" style="padding-left: 250px;">
        <div
          v-show="!!bindDevicePrivateItem && !bindDevicePrivateItem.is_ha_mode"
          class="default-button"
          :class="!mainBackMode ? '' : 'active-button'"
          @click="handleCenterDeviceInfo()">主备模式</div>
        <div
          v-show="!!bindDevicePrivateItem && !!bindDevicePrivateItem.is_ha_mode"
          class="default-button"
          :class="!highAvailabilityMode ? '' : 'active-button'"
          @click="handlecenterDeviceFingerprint()">高可用模式</div>
      </div>
      <div class="device-border"></div>
      <div class="add-device-form">
        <el-form :model="mainBackData" ref="mainBackData" v-if="mainBackMode">
          <el-form-item
            label="配置方式"
            prop="configMode"
            key="configMode"
            :rules="[{required: true, message: '请选择配置方式', trigger: 'change'}]"
          >
            <el-radio-group v-model="mainBackData.configMode">
              <el-radio label="DeviceInfo">上传设备信息</el-radio>
              <el-radio label="DeviceFinger">输入设备指纹</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="主服务器IP"
            prop="mainip"
            key="mainip"
            :rules="[{required: true, validator:validateIPAddress, trigger: 'blur'}]">
            <el-input
              v-model="mainBackData.mainip"
              autocomplete="on"
              :maxlength="32">
            </el-input>
         </el-form-item>
          <el-form-item label="* 主服务器设备信息文件" ref="mainDeviceInfoFile" v-if="mainBackData.configMode === 'DeviceInfo'">
            <form-item-upload-file
              :validateFile="mainBackData.mainFileValidateResult.validate"
              :ErrorName="DeviceInfoErrorName"
              :NeedConfirm="false"
              :allFormatType="true"
              :twentyM="true"
              @validateInfoResult="(data) => configDeviceInfoValidateResult(data, 'MBMode', 'main')">
            </form-item-upload-file>
            <a href="https://docs.qq.com/doc/DZFBKRU9RTW54cWZt" target="_blank">如何得到机器信息文件</a>
          </el-form-item>
          <el-form-item
            v-else
            label="主服务器设备指纹"
            prop="mainMD5"
            key="mainMD5"
            :rules="[{required: true, validator:validateMD5, trigger: 'blur'}]">
            <el-input
              v-model="mainBackData.mainMD5"
              autocomplete="on"
              :maxlength="32">
            </el-input>
         </el-form-item>
         <el-form-item
            label="备份服务器IP"
            prop="backip"
            key="backip"
            :rules="[{required: true, validator:validateIPAddress, trigger: 'blur'}]">
            <el-input
              v-model="mainBackData.backip"
              autocomplete="on"
              :maxlength="32">
            </el-input>
          </el-form-item>
          <el-form-item label="* 备份服务器设备信息文件" ref="backDeviceInfoFile" v-if="mainBackData.configMode === 'DeviceInfo'">
            <form-item-upload-file
              :validateFile="mainBackData.backFileValidateResult.validate"
              :ErrorName="DeviceInfoErrorName"
              :NeedConfirm="false"
              :allFormatType="true"
              :twentyM="true"
              @validateInfoResult="(data) => configDeviceInfoValidateResult(data, 'MBMode', 'back')">
            </form-item-upload-file>
            <a href="https://docs.qq.com/doc/DZFBKRU9RTW54cWZt" target="_blank">如何得到机器信息文件</a>
          </el-form-item>
          <el-form-item
            v-else
            label="备份服务器设备指纹"
            prop="backMD5"
            key="backMD5"
            :rules="[{required: true, validator:validateMD5, trigger: 'blur'}]">
            <el-input
              v-model="mainBackData.backMD5"
              autocomplete="on"
              :maxlength="32">
            </el-input>
         </el-form-item>
        </el-form>
        <el-form :model="highAvailabilityData" ref="highAvailabilityData" v-else>
          <el-form-item
            label="配置方式"
            prop="configMode"
            key="configMode"
            :rules="[{required: true, message: '请选择配置方式', trigger: 'change'}]"
          >
            <el-radio-group v-model="highAvailabilityData.configMode">
              <el-radio label="DeviceInfo">上传设备信息</el-radio>
              <el-radio label="DeviceFinger">输入设备指纹</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="dynamic-form-item">
            <div v-for="(item, index) in highAvailabilityData.CenterBindInfoPair" :key="item.key" class="device-group">
              <el-form-item
                :label="`服务器${index + 1}-IP`"
                :prop="'CenterBindInfoPair.' + index + '.ip'"
                :key="`${item.key}-${index}-ip`"
                :rules="[{required: true, validator:validateIPAddress, trigger: 'blur'}]">
                <el-input
                  v-model="item.ip"
                  autocomplete="on"
                  :maxlength="32">
                </el-input>
              </el-form-item>
              <el-form-item
                :label="`服务器${index + 1}-设备信息文件`"
                :ref="`HADeviceInfoFile_${item.key}`"
                v-if="highAvailabilityData.configMode === 'DeviceInfo'"
              >
                <form-item-upload-file
                  :validateFile="item.validate"
                  :ErrorName="DeviceInfoErrorName"
                  :NeedConfirm="false"
                  :allFormatType="true"
                  :twentyM="true"
                  @validateInfoResult="(data) => configDeviceInfoValidateResult(data, 'HAMode', item.key)">
                </form-item-upload-file>
                <a href="https://docs.qq.com/doc/DZFBKRU9RTW54cWZt" target="_blank">如何得到机器信息文件</a>
              </el-form-item>
              <el-form-item
                v-else
                :label="`服务器${index + 1}-设备指纹`"
                :prop="'CenterBindInfoPair.' + index + '.md5'"
                :key="`${item.key}-${index}-md5`"
                :rules="[{required: true, validator:validateMD5, trigger: 'blur'}]">
                <el-input
                  v-model="item.md5"
                  autocomplete="on"
                  :maxlength="32">
                </el-input>
              </el-form-item>
              <div class="delete-container" v-if="index + 1 > 3">
                <div class="connect-border"></div>
                <el-button type="text" @click="deleteHADeviceFormItem(index)">删除</el-button>
              </div>
            </div>
          </div>
          <el-form-item label="add" class="opacity-0">
            <el-button type="text" :disabled="disabledAddHADevice" @click="addHADeviceFormItem">+ 添加服务器</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmBindDeviceForm()">确 定</el-button>
        <el-button @click="cancleBindDeviceForm()">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 手动绑定 -->
    <el-dialog
      title="添加设备"
      :visible.sync="addDeviceVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :before-close="cancleBindDeviceForm"
      class="add-device-dialog"
      width="900px">
      <div class="device-button">
        <div
          class="default-button"
          :class="!deviceShow ? '' : 'active-button'"
          @click="handleDevice()">添加设备</div>
        <div
          class="default-button"
          :class="!deviceGroupShow ? '' : 'active-button'"
          @click="handleGroupDevice()">批量添加设备</div>
        <div
          class="default-button"
          :class="!deviceInfoShow ? '' : 'active-button'"
          @click="handleDeviceInfo()">上传设备信息</div>
        <div
          class="default-button"
          :class="!deviceFingerprintShow ? '' : 'active-button'"
          @click="handleDeviceFingerprint()">输入设备指纹</div>
      </div>
      <div class="device-border"></div>
      <!-- 添加设备 -->
      <div class="add-device-form" v-show="deviceShow">
        <el-form :model="addDeviceNoData"  ref="addDeviceNoData">
          <el-form-item prop="devno" label="设备号" key="devno"
            :rules="[{required: true, validator: validateDevno, trigger: ['change', 'blur']}]">
            <el-input v-model="addDeviceNoData.devno" placeholder="请输入设备号" :maxlength="100"></el-input>
          </el-form-item>
          <el-form-item prop="remark" label="备注" key="deviceRemarks"
            :rules="[{required: true, message: '备注不能为空', trigger: ['change', 'blur']}]">
            <el-input v-model="addDeviceNoData.remark" placeholder="最多输入32个字符" :maxlength="32"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <!-- 批量添加设备文件 -->
      <div class="add-device-form" v-show="deviceGroupShow">
        <el-form ref="groupAddDeviceValidateData">
          <el-form-item label="* 添加文件" ref="deviceGroupFile">
            <form-item-upload-file
              :validateFile="validateFileDevice"
              :ErrorName="ErrorName"
              :dialogVisible="groupAddDeviceVisible"
              :NeedConfirm="false"
              :formatCSV="true"
              :twentyM="true"
              @validateInfoResult="deviceValidateResult">
            </form-item-upload-file>
          </el-form-item>
          <el-form-item label="示例文件">
            <a class="group-add-device" href="\static\example\sample.csv" download>批量绑定设备示例文件</a>
          </el-form-item>
        </el-form>
      </div>

      <!-- 添加设备机器信息 -->
      <div class="add-device-form" v-show="deviceInfoShow">
        <el-form :model="deviceInfoData" ref="deviceInfoData">
          <el-form-item label="* 机器信息文件" ref="deviceInfoFile">
            <form-item-upload-file
              :validateFile="validateFileDeviceInfo"
              :ErrorName="DeviceInfoErrorName"
              :dialogVisible="deviceInfoVisible"
              :NeedConfirm="false"
              :allFormatType="true"
              :twentyM="true"
              @validateInfoResult="deviceInfoValidateResult">
            </form-item-upload-file>
            <a href="https://docs.qq.com/doc/DZFBKRU9RTW54cWZt" target="_blank">如何得到机器信息文件</a>
          </el-form-item>
          <el-form-item
            label="备注"
            prop="remark"
            key="remark"
            :rules="[{required: true, message: '备注不能为空', trigger: ['blur', 'change']}]">
            <el-input
              v-model="deviceInfoData.remark"
              placeholder="最多输入32个字符"
              :maxlength="32">
            </el-input>
          </el-form-item>
          <el-form-item prop="service" class="service" label="* 服务配置" key="serviceConfig" v-if="gpuBindInfo.length > 0">
            <div v-for="(svc, index) in svcList" :key="index">
              <div class="service-item">
                <el-tooltip class="item" effect="dark" :content="svc.name" placement="right-end">
                  <span class="name">{{svc.name}}</span>
                </el-tooltip>
                <div>
                  <span class="red">剩余{{svc.rest}}卡 </span>
                  <el-input-number size="small" v-model.number="svcListGPU[svc.type]" :min="1" :max="9999"/>
                  实例，每实例
                  <el-input-number size="small" v-model.number="svcListInstance[svc.type]" :min="0" :max="Math.floor(svc.rest/(svcListGPU[svc.type] || 1))" />
                  卡
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <!-- 添加设备 -->
      <div class="add-device-form" v-show="deviceFingerprintShow">
        <el-form :model="addDeviceFingerprintData"  ref="addDeviceFingerprintData">
          <el-form-item prop="fingerprint" label="设备指纹" key="fingerprint"
            :rules="[{required: true, validator: validateFingerprint, trigger: ['change', 'blur']}]">
            <el-input v-model="addDeviceFingerprintData.fingerprint" placeholder="请输入设备号" :maxlength="100"></el-input>
          </el-form-item>
          <el-form-item prop="remark" label="备注" key="deviceRemarks"
            :rules="[{required: true, message: '备注不能为空', trigger: ['change', 'blur']}]">
            <el-input v-model="addDeviceFingerprintData.remark" placeholder="最多输入32个字符" :maxlength="32"></el-input>
          </el-form-item>
          <el-form-item prop="service" class="service" label="* 服务配置" key="serviceConfig" v-if="gpuBindInfo.length > 0">
            <div v-for="(svc, index) in svcList" :key="index">
              <div class="service-item">
                <el-tooltip class="item" effect="dark" :content="svc.name" placement="right-end">
                  <span class="name">{{svc.name}}</span>
                </el-tooltip>
                <div>
                  <span class="red">剩余{{svc.rest}}卡 </span>
                  <el-input-number size="small" v-model.number="svcListGPU[svc.type]" :min="1" :max="9999"/>
                  实例，每实例
                  <el-input-number size="small" v-model.number="svcListInstance[svc.type]" :min="0" :max="Math.floor(svc.rest/(svcListGPU[svc.type] || 1))" />
                  卡
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmBindDeviceForm()">确 定</el-button>
        <el-button @click="cancleBindDeviceForm()">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 合同，合作备案 -->
    <el-dialog
      :title="`请添加${dialogContractTitle}`"
      :visible.sync="contractFormalVisible"
      :modal-append-to-body=false
      :close-on-click-modal=false
      :before-close="cancleContractForm"
      width="700px">
      <div class="add-device-form">
        <el-form ref="contractForm" :model="renewalValidateForm" :rules="rulesRenewal">
          <el-form-item :label="`* ${dialogContractText}`" ref="formalPrivate" v-if="renewalVisibleFile">
            <form-item-upload-file
              :validateFile="validateFileContract"
              :ErrorName="ErrorNameText"
              :dialogVisible="contractFormalVisible"
              :NeedConfirm="false"
              :twentyM="true"
              @validateInfoResult="handleValidateUploadResultContract">
            </form-item-upload-file>
          </el-form-item>
          <el-form-item
            class="demand-textarea"
            :class="{'show-renewal': renewalVisible}"
            label="续期需求"
            prop="demand">
            <el-input type="textarea" v-model="renewalValidateForm.demand"
              placeholder="如：增加3台设备/延长两个月/增加天眼交通" :maxlength="200"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" v-if="renewalVisible" @click="confirmRenewalAuth()">提交审核</el-button>
        <el-button type="primary" v-else @click="confirmApplyAuth()">提交审核</el-button>
        <el-button @click="cancleContractForm()">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 邮件列表 -->
    <el-dialog
      title="邮件列表"
      :visible.sync="mailReceiverVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :before-close="resetmailReceiverForm"
      width="700px">
      <div class="add-device-form">
        <el-form :model="mailReceiverData" :rules="rulesReceiver" ref="mailReceiverForm">
          <el-form-item prop="receiver" label="授权到期知会人">
            <el-input type="textarea" v-model="mailReceiverData.receiver" placeholder="授权到期前会邮件提醒，如有多个接收人请以;分隔" :maxlength="500"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitChangeMailReceiver()">确 定</el-button>
        <el-button @click="resetmailReceiverForm()">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 修改备注 -->
    <el-dialog
      title="修改备注"
      :visible.sync="remarksVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :before-close="resetRemarksData"
      width="700px">
      <div class="update-remarks-form">
        <el-form :model="remarksData" ref="remarksRef">
          <el-form-item
            prop="remark"
            label="备注"
            placeholder="最多输入32个字符"
            :rules="[{required: true, validator: validateRemarks}]">
            <el-input v-model="remarksData.remark" :maxlength="32"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRemarksData()">确定</el-button>
        <el-button @click="resetRemarksData()">取消</el-button>
      </div>
    </el-dialog>
    <!-- 密码添加 -->
    <password-add
      ref="addRef"
      v-model="addShow"
      @query="getAllPrivate">
    </password-add>
  </div>
</template>
<script>
import PrivateCloudDisplay from './js/PrivateCloudDisplay';
export default PrivateCloudDisplay;
</script>
<style lang='less'>
@import "../../../../../styles/btn.less";
@import "./css/common-display.less";
@import "./css/private-cloud-display.less";
.open-private-display {
  .add-device-dialog {
    .add-device-form {
      .el-form-item__content, .el-select{
        width: 530px;
      }
      .service{
        .service-item{
          margin-bottom: 5px;
          display: flex;
          justify-content: space-between;
          font-size: 13px;
          .el-input-number--small .el-input-number__decrease, .el-input-number--small .el-input-number__increase {
            width: 28px;
          }
          .name {
            max-width: 155px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .red {
            color: #e94e56;
          }
          .el-input-number {
            width: 105px;
            line-height: 30px;
          }
        }
      }
    }
    .el-dialog__footer {
      padding: 0 240px 50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/application/panels/PrivateCloudDisplay.vue